export const FULLFLIGHT_CONSTS = {
  NAMESPACE: 'fullflight',
  GET_TAIL_DATA: 'getAircraftData',
  GET_FLIGHT_DATA: 'getFlightData',
  GET_FLIGHT_PARAMETER_DATA: 'getFlightParameterData',
  GET_COMPLETE_FULL_FLIGHT_DATA: 'getCompleteFullFlightData',
  UPDATE_PARAMETER_DATA: 'updateParameterData',
  UPDATE_TAIL_DATA: 'updateTailData',
  UPDATE_FLIGHT_DATA: 'updateFlightData',
  UPDATE_FLIGHT_PARAMETER_DATA: 'updateFlightParameterData',
  UPDATE_FULL_FLIGHT_PARAMETER_DATA: 'updateFullFlightParameterData',
  UPDATE_COMPONENTS_DATA: 'updateComponentsData',
  ADD_SELECTOR: 'addSelector',
  UPDATE_SELECTOR: 'updateSelector',
  UPDATE_SELECTOR_NODATA: 'updateSelectorNoData',
  REMOVE_SELECTOR: 'removeSelector',
  HIDE_PARAM: 'hideParameter',
  UPDATE_LOADING_SELECTOR: 'loadingSelector',
  UPDATE_MULTI_FLIGHT_LOADING_SELECTOR: 'multiFlightLoadingSelector',
  UPDATE_SAVE_FILTERS_FLAG: 'updateSaveFiltersFlag',
  GET_SAVE_FILTERS_FLAG: 'getSaveFiltersFlag',
  LOAD_SAVE_FILTERS_FLAG: 'loadSaveFiltersFlag',
  SAVE_USER_FILTERS: 'saveUserFilters',
  LOAD_USER_FILTERS: 'loadUserFilters',
  NAMESPACED_PIECE(constVal) {
    return this.NAMESPACE + '/' + constVal
  },
}

export const CUSTOM_ALERT_CONSTS = {
  NAMESPACE: 'customAlerts',
  GET_CUSTOM_ALERTS: 'getCustomAlerts',
  GET_SHARED_ALERTS_FOR_AIRLINE: 'getSharedAnalyticsForAirline',
  GET_CUSTOM_ALERT: 'getCustomAlert',
  GET_CUSTOM_ALERT_TYPES: 'getCustomAlertTypes',
  SET_CUSTOM_ALERT_TYPES: 'setCustomAlertTypes',
  SET_CURRENT_ALERT: 'setCurrentAlert',
  GET_PARAMETER_LIST: 'getParameterList',
  GET_FULLFLIGHT_PARAMETER_LIST: 'getFullFlightParameterList',
  GET_SNAPSHOT_PARAMETER_LIST: 'getSnapshotParameterList',
  SAVE_CUSTOM_ALERT: 'saveCustomAlert',
  SAVE_MASS_CUSTOM_ALERTS: 'saveMassCustomAlert',
  DELETE_CUSTOM_ALERT: 'deleteCustomAlert',
  TOGGLE_ALERT: 'toggleAlert',
  UPDATE_CUSTOM_ALERTS: 'updateCustomAlerts',
  UPDATE_CUSTOM_ALERT: 'updateCustomAlert',
  UPDATE_SHARED_CUSTOM_ALERTS: 'updateSharedCustomAlerts',
  UPDATE_PARAMETER_LIST: 'updateParameterList',
  GET_PARAMETER_TAIL_LIST: 'getParameterTailList',
  UPDATE_PARAMETER_TAIL_LIST: 'updateParameterTailList',
  GET_HISTOGRAM_DATA: 'getHistogramData',
  DUPLICATE_CURRENT_ALERT: 'duplicateCurrentAlert',
  RESET_CURRENT_CUSTOM_ALERT: 'resetCurrentCustomAlert',
  RESET_CUSTOM_ALERT: 'resetCustomAlert',
  APPEND_CUSTOM_ALERT: 'appendCustomAlert',
  GET_ADVANCED_ALERT_TAIL_LIST: 'getAdvancedAlertTailList',
  UPDATE_ADVANCED_ALERT_TAIL_LIST: 'updateAdvancedAlertTailList',
  UPDATE_CUSTOM_ALERT_FUNCTIONS: 'updateCustomAlertFunctions',
  GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE: 'getLogicBuilderGuide',
  UPDATE_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE: 'updateLogicBuilderGuide',
  GET_LOGIC_VALIDATION: 'getLogicValidation',
  GET_CUSTOM_ALERT_FUNCTIONS: 'getCustomAlertFunctions',
  ADVANCED_CUSTOM_ALERT_PARAMETER_LIMIT: 16,
  GET_PART_NUMBERS: 'getPartNumbers',
  SET_PART_NUMBERS: 'setPartNumbers',
  GET_CUSTOM_ALERT_PERFORMANCE: 'getCustomAlertPerformance',
  ACMF_SIMPLE_ID: 1,
  CPL_SIMPLE_ID: 2,
  ACMF_ADVANCED_ID: 3,
  CPL_ADVANCED_ID: 4,
  DPLF_ADVANCED_ID: 5,
  PERSISTENCE_DAYS_TYPE: 'aggregateDays',
  PERSISTENCE_REPORTS_TYPE: 'aggregateReports',
  PERSISTENCE_FLIGHTS_TYPE: 'persistence',
  UPDATE_ACTIVATION_NOTIFICATIONS: 'updateActivationNotifications',
  TRIGGER_DATABRICKS: 'triggerDataBricks',
  GET_LOOKBACK_STATE_RUNID: 'getLookbackStateRunId',
  UPDATE_CUSTOM_ALERT_DATABRICKS_RUNID: 'update_custom_alert_databricks_runid',
  UPDATE_DATABRICKS_RESPONSE: 'update_databricks',
  CANCEL_LOOKBACK: 'cancel_lookback',
  SEE_PERFORMANCE_ESTIMATE: 'See Performance Estimate',
  RUN_PERFORMANCE_ESTIMATE: 'Run Performance Estimate',
  CANCEL_RUNNING_GETSTATUS_LOOKBACK_API:
    'Cancel Running Getstatus Lookback API',
  UPDATE_CUSTOM_ANALYTIC_RUN_COUNT: 'updateCustomAnalyticRunCount',
  GET_CUSTOM_ANALYTIC_RUN_COUNT: 'getCustomAnalyticRunCount',
  GET_LOOKBACK_RUNCOUNT: 'getLookbackRunCount',
}

export const CUSTOM_ALERTS_DERIVED_PARAMETERS_CONSTS = {
  NAMESPACE: 'derivedParameters',
  GET_DERIVED_PARAMETER_VALIDATOR: 'derivedParameterValidator',
  UPDATE_DERIVED_PARAMETER_VALIDATOR: 'updateDerivedParameterValidator',
  GET_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE:
    'getDerivedParameterLogicBuilderGuide',
  UPDATE_DERIVED_PARAMETER_ALERT_LOGIC_BUILDER_GUIDE:
    'updateDerivedParameterLogicBuilderGuide',
  DERIVED_PARAMETER_ALERT_PARAMETER_LIMIT: 4,
  SAVE_CUSTOM_PARAMETER: 'saveCustomParameter',
  APPEND_CUSTOM_PARAMETER: 'appendCustomParameter',
  UPDATE_DERIVED_PARAMETER: 'updateDerivedParameter',
  GET_DERIVED_PARAMETERS: 'getDerivedParameters',
  GET_DERIVED_PARAMETERS_BY_AIRLINE_ID: 'getDerivedParametersByAirlineId',
  UPDATE_DERIVED_PARAMETERS: 'updateDerivedParameters',
  DELETE_DERIVED_PARAMETER: 'deleteDerivedParameter',
  GET_DERIVED_PARAMETER: 'getDerivedParameter',
}

export const CONNECTIVITY_CONSTS = {
  NAMESPACE: 'connectivity',
  GET_CONNECTIVITY_SUMMARY: 'getConnectivitySummary',
  GET_CONNECTIVITY_FULL_SUMMARY: 'getConnectivityFullSummary',
  GET_FULL_CONNECTIVITY_ISSUES: 'getFullConnectivityIssues',
  UPDATE_CONN_DATA: 'updateConnData',
  UPDATE_FULL_DATA: 'updateFullData',
  UPDATE_CONN_ISSUES: 'updateConnectivityIssues',
}

export const FLIGHT_PHASE_CONSTS = {
  NAMESPACE: 'flightPhase',
  GET_FLIGHT_PHASES: 'getFlightPhases',
  UPDATE_FLIGHT_PHASES: 'updateFlightPhases',
}

export const PLOT_CONSTS = {
  NAMESPACE: 'plot',
  GET_PLOTS: 'getPlots',
  SAVE_PLOT: 'savePlot',
  DELETE_PLOT: 'deletePlot',
  UPDATE_PLOTS: 'updatePlots',
  GET_PLOT_IMAGE_SRC: 'getPlotImageSrc',
  UPDATE_PLOT_IMAGE_SRC: 'updatePlotImageSrc',
  UPDATE_SAVE_SERVER_ID: 'updateSaveServerId',
  UPDATE_PAGE_PLOTS: 'updatePagePlots',
  UPDATE_CHART_DATA: 'updateChart',
}

export const PLOTLY_CONSTS = {
  NAMESPACE: 'plotly',
  GET_PLOTLY_TOKEN: 'getPlotlyToken',
  UPDATE_PLOTLY_TOKEN: 'updatePlotlyToken',
  SAVE_DASH_SELECTIONS: 'saveDashSelections',
  UPDATE_DASH_SELECTIONS: 'updateDashSelections',
  CREATE_ISSUE_DASH: 'createIssueFromDash',
  REPEATER_RELATEDEVENT_GRID_DASH : 'saveRepeaterDashSelections',
  CANCEL_DASH_SELECTIONS: 'cancelDashSelections',
  RESET_DASH_SELECTIONS: 'resetDashSelections',
}

export const ANSER_TOOL_CONSTS = {
  NAMESPACE: 'anserTool',
  GET_SIGNATURES: 'getSignatures',
  UPDATE_SIGNATURES: 'updateSignatures',
  SIGNATURES_LOADING: 'signaturesLoading',
}

export const ANALYTIC_COMPARISON_CONSTS = {
  NAMESPACE: 'analyticComparison',
  GET_ACC_ANALYTIC_COMPONENTS: 'getAccAnalyticComponents',
  GET_ACC_ANALYTICS: 'getAccAnalytics',
  GET_ACC_FEATURES: 'getAccFeatures',
  GET_ACC_RISK_SCORES: 'getAccRiskScores',
  UPDATE_ACC_ANALYTIC_COMPONENTS: 'updateAccAnalyticComponents',
  UPDATE_ACC_ANALYTICS: 'updateAccAnalytics',
  UPDATE_ACC_FEATURES: 'updateAccFeatures',
  UPDATE_ACC_RISK_SCORES: 'updateAccRiskScores',
}

export const ANALYTIC_MODULE_CONSTS = {
  NAMESPACE: 'analyticModule',
  ALL_ANALYTIC_MODULES_LOADING: 'allAnalyticModulesLoading',
  GET_AMC_ANALYTIC_MODULES: 'getAmcAnalyticModules',
  GET_AMC_ANALYTIC_TRENDS_DATA: 'getAmcAnalyticTrendsData',
  GET_AMC_ANALYTIC_COMPARISON_DATA: 'getAmcAnalyticComparisonData',
  GET_AMC_FEATURES: 'getAmcFeatures',
  GET_ANALYTIC_MODULE: 'getAnalyticModule',
  GET_ANALYTIC_MODULES: 'getAnalyticModules',
  GET_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES: 'getAscentiaAnalyticsWithAlertTypes',
  GET_CUSTOM_MX_REC_ENTRY: 'getCustomMxRecEntry',
  SAVE_ANALYTIC_MODULE: 'saveAnalyticModule',
  SAVE_MODULE_TOAST_NOTIFICATION: 'saveModuleToastNotification',
  UPDATE_ANALYTIC_MODULE: 'updateAnalyticModule',
  UPDATE_AMC_ANALYTIC_MODULES: 'updateAmcAnalyticModules',
  UPDATE_AMC_PAGE_PLOT_FEATURES: 'updateAmcPagePlotFeatures',
  SET_AMC_PAGE_PLOT_FEATURES: 'setAmcPagePlotFeatures',
  UPDATE_AMC_ANALYTIC_TRENDS_DATA: 'updateAmcAnalyticTrendsData',
  UPDATE_AMC_ANALYTIC_COMPARISON_FILTERS: 'updateAmcAnalyticComparisonFilters',
  UPDATE_AMC_ANALYTIC_COMPARISON_DATA: 'updateAmcAnalyticComparisonData',
  UPDATE_AMC_ANALYTIC_COMPARISON_DATA_MISSING_TAILS:
    'updateAmcAnalyticComparisonDataMissingTails',
  UPDATE_AMC_FEATURES: 'updateAmcFeatures',
  UPDATE_ANALYTIC_MODULES: 'updateAnalyticModules',
  UPDATE_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR:
    'updateAmcPagePlotFeaturesWithSelector',
  UPDATE_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES:
    'updateAscentiaAnalyticsWithAlertTypes',
  SET_AMC_PAGE_PLOT_FEATURES_WITH_SELECTOR:
    'setAmcPagePlotFeaturesWithSelector',
  UPDATE_CUSTOM_MX_REC_ENTRY: 'updateCustomMxRecEntry',
  SAVE_CUSTOM_MX_REC_ENTRY: 'saveCustomMxRecEntry',
  SAVING_CUSTOM_MX_REC_ENTRY: 'savingCustomMxRecEntry',
}

export const ANALYTICS_CONSTS = {
  NAMESPACE: 'analytics',
  GET_ANALYTIC_RESULT_TYPES: 'getAnalyticResultTypes',
  GET_QUARTILE_RESULTS: 'getQuartileResults',
  UPDATE_SELECTOR: 'updateSelector',
  UPDATE_ANALYTIC_RESULT_TYPES: 'updateAnalyticResultTypes',
  UPDATE_QUARTILE_RAW_RESULTS: 'updateQuartileRawResults',
  UPDATE_QUARTILE_RESULTS: 'updateQuartileResults',
  UPDATE_QUARTILE_SPLIT_RESULTS: 'updateQuartileSplitResults',
  UPDATE_QUARTILE_SPLIT_RESULTS_MISSING_TAILS:
    'updateQuartileSplitResultsMissingTails',
  UPDATE_SORT_ITEM: 'updateSortItem',
}

export const WATCHLIST_CONSTS = {
  NAMESPACE: 'watchlist',
  GET_ALL_RISK_SCORES_BY_TAIL: 'getAllRiskScoresByTail',
  GET_RISK_SCORE_FRIENDLY_NAMES: 'getRiskScoreFriendlyNames',
  GET_WATCHLIST_RISK_SCORE_LIST: 'getWatchlistRiskScoreList',
  GET_WATCHLIST_FEATURE_LIST: 'getWatchlistFeatureList',
  GET_FEATURE_DATA: 'getFeatureData',
  GET_PHM_ALERTS: 'getPhmAlerts',

  UPDATE_RISK_SCORES_BY_TAIL: 'updateRiskScoresByTail',
  UPDATE_WATCHLIST_DRILLDOWN_SELECTION: 'updateWatchlistDrilldownSelection',
  ADD_RISK_SCORES_BY_TAIL: 'addRiskScoresByTail',
  UPDATE_RISK_SCORE_FRIENDLY_NAMES: 'updateRiskScoreFriendlyNames',
  ADD_RISK_SCORE_FRIENDLY_NAMES: 'addRiskScoreFriendlyNames',
  UPDATE_WATCHLIST_FILTERS: 'updateWatchlistFilters',
  UPDATE_WATCHLIST_RISK_SCORE_LIST: 'updateWatchlistRiskScoreList',
  UPDATE_WATCHLIST_FEATURE_LIST: 'updateWatchlistFeatureList',
  UPDATE_FEATURE_DATA: 'updateFeatureData',
  UPDATE_PHM_ALERT_VALUES: 'updatePhmAlertValues',

  UPDATE_SELECTOR: 'updateSelector',
  ADD_SELECTOR: 'addSelector',
  REMOVE_SELECTOR: 'removeSelector',
  CLEAR_SELECTORS: 'clearSelectors',
  HIDE_SELECTOR: 'hideSelector',
}

export const DPLF_CONSTS = {
  NAMESPACE: 'dplf',
  GET_FAULT_MSG_COUNT_BY_TAIL: 'getFaultMsgCountByTail',
  UPDATE_FAULT_MSG_COUNT_BY_TAIL: 'updateFaultMsgCountByTail',
  GET_FAULT_MSG_COUNT_BY_ATA_CHAPTER: 'getFaultMsgCountByAtaChapter',
  UPDATE_FAULT_MSG_COUNT_BY_ATA_CHAPTER: 'updateFaultMsgCountByAtaChapter',
  GET_FAULT_MSG_COUNT_BY_PARA: 'getFaultMsgCountByPara',
  UPDATE_FAULT_MSG_COUNT_BY_PARA: 'updateFaultMsgCountByPara',
  GET_FAULT_MSG_CODES: 'getFaultMsgCodes',
  UPDATE_FAULT_MSG_CODES: 'updateFaultMsgCodes',
  GET_FAULT_REPORTS_BY_FLIGHT: 'getFaultReportsByFlight',
  UPDATE_FAULT_REPORTS_BY_FLIGHT: 'updateFaultReportsByFlight',
  GET_MESSAGE_CODES: 'getMessageCodes',
  UPDATE_MESSAGE_CODES: 'updateMessageCodes',
  UPDATE_ATA_CHAPTER_OPTIONS: 'updateAtaChapterOptions',
  GET_ATA_CHAPTER_OPTIONS_DATA: 'getAtaChapterOptionsData',
  GET_FAULT_MSG_RAW_REPORT: 'getFaultMsgRawReport',
  UPDATE_FAULT_MSG_RAW_REPORT: 'updateFaultMsgRawReport',
  GET_FAULT_MSG_DETAILS: 'getFaultMsgDetails',
  UPDATE_FAULT_MSG_DETAILS: 'updateFaultMsgDetails',
  GET_VISUALIZE_DETAILS: 'getVisualizeDetails',
  UPDATE_VISUALIZE_DETAILS: 'updateVisualizeDetails',
  RESET_CURRENT_DPLF_VALUES: 'resetCurrentDplfValues',
  RESET_DPLF_VALUES: 'resetDplfValues',
}

export const FLIGHTAWARE_CONSTS = {
  NAMESPACE: 'flightAware',
  GET_FUTURE_FLIGHT_SCHEDULES: 'getFutureFlightSchedules',
  UPDATE_FUTURE_FLIGHT_SCHEDULES: 'updateFutureFlightSchedules',
  GET_LAST_UPDATED_DATE: 'getLastUpdatedDate',
  UPDATE_LAST_UPDATED_DATE: 'updateLastUpdatedDate',
}

export const MESSAGES_CONSTS = {
  NAMESPACE: 'messages',
  GET_MAINTENANCE_REC_PDF: 'getMaintRecPdf',
  GET_DANDC_DATA: 'getDAndCData',
  UPDATE_DANDC_DATA: 'updateDAndCData',
}

export const USER_CONSTS = {
  NAMESPACE: 'user',
  GET_TANDC_DATA: 'getTermsAndConditionsAcceptance',
  SET_TANDC_DATA: 'setTermsAndConditionsAcceptance',
  UPDATE_TANDC_STATUS: 'updateTermsAndConditionsStatus',
  GET_USER_PROFILE: 'getUserProfile',
  SET_USER_AIRLINES: 'setUserAirlines',
  UPDATE_USER_AIRLINES: 'updateUserAirlines',
  SET_GEOIP_ACCEPTANCE: 'setGeoIPAcceptance',
  UPDATE_USER_PROFILE: 'updateUserProfile',
  SET_USER_FEEDBACK: 'setUserFeedback',
  GET_RELEASE_NOTES: 'getReleaseNotes',
  UPDATE_RELEASE_NOTES: 'updateReleaseNotes',
  GET_COMPANY_LIST: 'getCompanyList',
  UPDATE_COMPANY_LIST: 'updateCompanyList',
  SET_COMPANY_LIST: 'setCompanyList',
  UPDATE_NEW_COMPANY: 'updateNewCompany',
  GET_USER_HELP_GUIDE: 'getUserHelpGuide',
  UPDATE_USER_HELP_GUIDE: 'updateUserHelpGuide',
}

export const LOOKUP_CONSTS = {
  NAMESPACE: 'lookups',
  GET_AIRCRAFTS: 'getAircrafts',
  GET_ANALYTICS: 'getAnalytics',
  GET_ATA_CHAPTERS: 'getAtaChapters',
  GET_ATA_SUBCHAPTERS: 'getAtaSubchapters',
  GET_COMPONENTS: 'getComponents',
  GET_FEATURES: 'getFeatures',
  GET_FLIGHT_PHASES: 'getFlightPhases',
  GET_MASTER_MODELS: 'getMasterModels',
  GET_OPERATORS: 'getOperators',
  GET_PARAMETERS_WITH_ID: 'getParametersWithId',
  GET_SUPPORTING_INFO_TYPES: 'getSupportingInfoTypes',
  UPDATE_OPERATORS: 'updateOperators',
  UPDATE_SYSTEMS: 'updateSystems',
  GET_PARAMETERS: 'getParameters',
  GET_ROLES: 'getRoles',
  GET_SYSTEMS: 'getSystems',
  GET_MODELS: 'getModels',
  UPDATE_AIRCRAFTS: 'updateAircrafts',
  UPDATE_AIRCRAFTS_LOADING: 'updateAircraftsLoading',
  UPDATE_AIRLINES: 'updateAirlines',
  UPDATE_ANALYTICS: 'updateAnalytics',
  UPDATE_ATA_CHAPTERS: 'updateAtaChapters',
  UPDATE_ATA_SUBCHAPTERS: 'updateAtaSubchapters',
  UPDATE_COMPONENTS: 'updateComponents',
  UPDATE_FEATURES: 'updateFeatures',
  UPDATE_FLIGHT_PHASES: 'updateFlightPhases',
  UPDATE_MASTER_MODELS: 'updateMasterModels',
  UPDATE_MASTER_MODELS_LOADING: 'updateMasterModelsLoading',
  UPDATE_AIRLINE_MASTERMODEL_AGREEMENT: 'updateAirlineMasterModelAgreement',
  UPDATE_PARAMETERS_WITH_ID: 'updateParametersWithId',
  UPDATE_PARAMETERS: 'updateParameters',
  UPDATE_ROLES: 'updateRoles',
  UPDATE_MODELS: 'updateModels',
  GET_PERMISSIONS: 'getPermissions',
  UPDATE_PERMISSIONS: 'updatePermissions',
}

export const AUTH_CONSTS = {
  NAMESPACE: 'auth',
  UPDATE_AUTH_DATA: 'updateAuthData',
  CLEAR_AUTH_DATA: 'clearAuthData',
}

export const SUBSCRIPTION_CENTER_CONSTS = {
  NAMESPACE: 'subscriptionCenter',
  GET_SUBSCRIPTIONS: 'getSubscriptions',
  UPDATE_SUBSCRIPTIONS: 'updateSubscriptions',
  SUBSCRIPTIONS_LOADING: 'subscriptionsLoading',
  SAVE_SUBSCRIPTIONS: 'saveSubscription',
  GET_SUBSCRIPTIONS_TYPES: 'getSubscriptionTypes',
  UPDATE_SUBSCRIPTIONS_TYPES: 'updateSubscriptionsTypes',
  GET_ANALYTIC_SYSTEMS: 'getAnalyticSystems',
  UPDATE_ANALYTIC_SYSTEMS: 'updateAnalyticSystems',
  UPDATE_SUBSCRIPTION: 'updateSubscription',
}

export const ADMIN_CONSTS = {
  NAMESPACE: 'admin',
  GET_USERS: 'getUsers',
  GET_USER_EMAIL_SUBSCRIPTIONS: 'getUserEmailSubscriptions',
  GET_USER_EMAIL_SUBSCRIPTION_TYPES: 'getUserEmailSubscriptionTypes',
  SET_USER: 'setUser',
  SET_USER_EMAIL_SUBSCRIPTIONS: 'setUserEmailSubscriptions',
  CREATE_USER: 'createUser',
  UPDATE_USER: 'updateUser',
  UPDATE_USERS: 'updateUsers',
  UPDATE_USER_EMAIL_SUBSCRIPTIONS: 'updateUserEmailSubscriptions',
  DELETE_USER_EMAIL_SUBSCRIPTION: 'deleteUserEmailSubscription',
  UPDATE_USER_EMAIL_SUBSCRIPTION_TYPES: 'updateUserEmailSubscriptionTypes',
  UPDATE_ALL_USERS_LOADING: 'updateAllUsersLoading',
  EDIT_USER_TOAST: 'editUserToast',
  NEW_USER_TOAST: 'newUserToast',
  UPDATE_NEW_LOADING: 'updateNewLoading',
  UPDATE_EDIT_LOADING: 'updateEditLoading',
  GET_SINGLE_USER: 'getSingleUser',
  UPDATE_SINGLE_USER: 'updateSingleUser',
  UPDATE_FAILED_USERS: 'updateFailedUsers',
  GET_REPORT_TYPES: 'getReportTypes',
  UPDATE_REPORT_TYPES: 'updateReportTypes',
  GET_ADMIN_MASTER_MODELS: 'getAdminMasterModels',
  UPDATE_ADMIN_MASTER_MODELS: 'updateAdminMasterModels',
}

export const MAINTENANCE_ISSUES_CONSTS = {
  NAMESPACE: 'maintenanceIssues',
  GET_MAINTENANCE_STATUSES: 'getMaintenanceStatuses',
  GET_SINGLE_MAINTENANCE_REC: 'getSingleMaintenanceRec',
  GET_MAINTENANCE_ISSUES: 'getAllMaintenanceIssues',
  GET_MAINTENANCE_ISSUE_BY_AIRLINE: 'getMaintenanceIssuesByAirline',
  GET_MAINTENANCE_ISSUES_WITH_STATUSES: 'getMaintenanceIssuesWithStatuses',
  GET_COMPONENT_SUMMARY: 'getComponentSummary',
  GET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION:
    'getCustomAlertMaintenanceIssueVersion',
  RESET_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION:
    'resetCustomAlertMaintenanceIssueVersion',
  GET_STATUS_SUMMARY: 'getStatusSummary',
  GET_TOP_DAYS_SINCE: 'getTopDaysSince',
  UPDATE_MAINTENANCE_ATTACHMENTS: 'updateMaintenanceAttachments',
  UPDATE_MAINTENANCE_ATTACHMENT_CAPTION: 'updateMaintenanceAttachmentCaption',
  SET_MAINTENANCE_ATTACHMENT_CAPTION: 'setMaintenanceAttachmentCaption',
  ADD_MAINTENANCE_ATTACHMENT: 'addMaintenanceAttachment',
  REMOVE_MAINTENANCE_ATTACHMENT: 'removeMaintenanceAttachment',
  GET_EXTERNAL_MAINTENANCE_RECS: 'getExternalMaintenanceRecs',
  UPDATE_MAINTENANCE_ISSUES: 'updateMaintenanceIssues',
  UPDATE_MAINTENANCE_STATUSES: 'updateMaintenanceStatuses',
  UPDATE_SINGLE_MAINTENANCE_ISSUE: 'updateSingleMaintenanceIssue',
  UPDATE_COMPONENT_SUMMARY: 'updateComponentSummary',
  UPDATE_CUSTOM_ALERT_MAINTENANCE_ISSUE_VERSION:
    'updateCustomAlertMaintenanceIssueVersion',
  UPDATE_STATUS_SUMMARY: 'updateStatusSummary',
  UPDATE_TOP_DAYS_SINCE: 'updateTopDaysSince',
  GET_MAINTENANCE_RECS: 'getMaintenanceRecs',
  UPDATE_MAINTENANCE_RECS: 'updateMaintenanceRecs',
  GET_MAINTENANCE_GRID: 'getMaintenanceGrid',
  UPDATE_MAINTENANCE_GRID: 'updateMaintenanceGrid',
  UPDATE_EXTERNAL_MAINTENANCE_RECS: 'updateExternalMaintenanceRecs',
  UPDATE_PLOT_TO_ISSUE_ID_LINK: 'updatePlotToIssueIdLink',
  DELETE_PLOT_LINK: 'deletePlotLink',
  UPDATE_ACTIVE_MXREC: 'updateActiveMxRec',
  UPDATE_ANALYTIC_PAGE_PLOTS: 'updateAnalyticPagePlots',
  UPDATE_ANALYTIC_PLOT_6_MONTHS_FROM_DATE: 'updateAnalyticPlot6MonthsFromDate',
  UPDATE_ANALYTIC_PLOT_30_DAYS_FROM_DATE: 'updateAnalyticPlot30DaysFromDate',
  UPDATE_ANALYTIC_PLOT_TO_DATE: 'updateAnalyticPlotToDate',
  RESET_ACTIVE_MXREC: 'resetActiveMxRec',
  GET_SESSION_EXPIRATION: 'getSessionExpiration',
  UPDATE_SESSION_EXPIRATION: 'updateSessionExpiration',
  GET_REMOVALS_DATA: 'getRemovalsData',
  UPDATE_REMOVALS_DATA: 'updateRemovalData',
  GET_REMOVALS_DATA_BY_TAIL: 'getRemovalsDataByTail',
  UPDATE_REMOVALS_DATA_BY_TAIL: 'updateRemovalDataByTail',
  GET_FAULT_MESSAGES_DATA: 'getFaultMessagesData',
  UPDATE_FAULT_MESSAGES_DATA: 'updateFaultMessagesData',
  UPDATE_DETAILS_DISCUSSION_ID: 'updateDetailsDiscussionId',
  UPDATE_INVESTIGATION_DISCUSSION_ID: 'updateInvestigationDiscussionId',
  UPDATE_DETAILS_DISCUSSION: 'updateDetailsDiscussion',
  UPDATE_INVESTIGATION_DISCUSSION: 'updateInvestigationDiscussion',
  GET_TAGGABLE_USERS: 'getTaggableUsers',
  UPDATE_INVESTIGATOR_USERS: 'updateInvestigatorUsers',
  UPDATE_DETAIL_USERS: 'updateDetailUsers',
  GET_DISCUSSIONS: 'getDiscussions',
  POST_DETAIL_DISCUSSION: 'postDetailDiscussion',
  UPDATE_DISCUSSIONS: 'updateDiscussions',
  GET_DISCUSSION_TYPES: 'getDiscussionTypes',
  ADD_DISCUSSION_COMMENT: 'addDiscussionComment',
  REMOVE_DISCUSSION_COMMENT: 'removeDiscussionComment',
  UPDATE_DISCUSSION_COMMENT: 'updateDiscussionComment',
  GET_MAINTENANCE_ISSUE_LOCK_STATUS: 'getIssueLockStatus',
  SAVE_MAINTENANCE_ISSUE_LOCK_STATUS: 'saveIssueLockStatus',
  GET_SUPPORTING_INFO_SELECTIONS: 'getSupportingInfoSelections',
  UPDATE_SUPPORTING_INFO_SELECTION_TYPES: 'updateSupportingInfoSelectionTypes',
  UPDATE_SUPPORTING_INFO_SELECTIONS: 'updateSupportingInfoSelections',
  UPDATE_SUPPORTING_INFO_ROW_SELECTION: 'updateSupportingInfoRowSelection',
  UPDATE_ROW_VISIBILITY: 'updateRowVisibility',
  SAVE_SUPPORTING_INFO_SELECTIONS: 'saveSupportingInfoSelections',
  UPDATE_SUPPORTING_INFO_CAPTION: 'updateSupportingInfoCaption',
  SET_CAPTION: 'setCaption',
  GET_PHM_ALERTS: 'getPHMAlerts',
  UPDATE_PHM_ALERTS: 'updatePHMAlerts',
  GET_MAINTENANCE_ISSUE_PLOTS: 'getMaintenanceIssuePlots',
  SET_MAINTENANCE_ISSUE_PLOTS: 'setMaintenanceIssuePlots',
  UPDATE_PLOT_VISIBILITY: 'updatePlotVisibility',
  SET_PLOT_VISIBILITY: 'setPlotVisibility',
  UPDATE_PLOT_ATTACHMENT: 'updatePlotAttachments',
  REMOVE_PLOT_ATTACHMENT: 'removePlotAttachments',
  ADD_PLOT_ATTACHMENT: 'addPlotAttachments',
  UPDATE_ATTACHMENT_VISIBILITY: 'updateAttachmentVisibility',
  SET_ATTACHMENT_VISIBILITY: 'setAttachmentVisibility',
  REMOVE_DELETED_PLOT_FROM_SELECTIONS: 'removeDeletedPlotFromSelections',
  RESET_MX_ERRORS: 'resetMxErrors',
  UPDATE_MX_ERRORS: 'updateMxErrors',
  GET_HOME_PAGE_MAINTENANCE_ISSUES: 'getHomePageMaintenanceIssues',
  UPDATE_HOME_PAGE_MAINTENANCE_ISSUES: 'updateHomePageMaintenanceIssues',
  GET_MAINTENANCE_ISSUES_RELATED_ISSUES: 'getMaintenanceIssuesRelatedIssues',
  UPDATE_RELATED_ALERTS: 'updateRelatedAlerts',
  UPDATE_RELATED_ISSUES: 'updateRelatedIssues',
  GET_AIRLINE_RESPONSE_OPTIONS: 'getAirlineResponseOptions',
  GET_REASON_TO_CLOSE_OPTIONS: 'getReasonToCloseOptions',
  GET_FIX_EFFECTIVENESS_OPTIONS: 'getFixEffectivenessOptions',
  GET_ANALYTIC_DETECTION_OUTCOME_OPTIONS: 'getAnalyticDetectionOutcomeOptions',
  GET_SERVICE_DELIVERY_OUTCOME_OPTIONS: 'getServiceDeliveryOutcomeOptions',
  GET_SEVERITY_OPTIONS: 'getSeverityOptions',
  UPDATE_SEVERITY_OPTIONS: 'updateSeverityOptions',
  UPDATE_FIX_EFFECTIVENESS_OPTIONS: 'updateFixEffectivenessOptions',
  UPDATE_SERVICE_DELIVERY_OUTCOME_OPTIONS:
    'updateServiceDeliveryOutcomeOptions',
  UPDATE_ANALYTIC_DETECTION_OUTCOME_OPTIONS:
    'updateAnalyticDetectionOutcomeOptions',
  UPDATE_REASON_TO_CLOSE_OPTIONS: 'updateReasonToCloseOptions',
  UPDATE_AIRLINE_RESPONSE_OPTIONS: 'updateAirlineResponseOptions',
  UPDATE_MXREC_ALERT_DETAILS: 'updateMxRecAlertDetails',
  UPDATE_MXREC_STATUS_DETAILS: 'updateMxRecStatusDetails',
  UPDATE_MXREC_VALIDATION_DETAILS: 'updateMxRecValidationDetails',
  UPDATE_MXREC_CONCLUDE_DETAILS: 'updateMxRecConcludeDetails',
  UPDATE_MXREC_FOLLOWUP_FIELDS: 'updateMxRecFollowUpFields',
  CANCEL_CHANGES: 'cancelMxRecChanges',
  UPDATE_PRESERVED_MXREC: 'updatePreservedMxRec',
  UPDATE_MXREC_RECOMMENDATION: 'updateMxRecRecommendation',
  UPDATE_MXREC_ALERTS_EXPORT_LOADING: 'updateMxRecAlertsExportLoading',
  GET_MXREC_ALERTS_EXPORT_GIVEN_OPTIONS: 'getMxRecAlertsExportGivenOptions',
  GET_ISSUE_SOURCE_OPTIONS: 'getIssueSourceOptions',
  UPDATE_ISSUE_SOURCE_OPTIONS: 'updateIssueSourceOptions',
  ADD_MANUAL_MAINTENANCE_ISSUE: 'addManualMaintenanceIssue',
  CREATE_NEW_REPEATER_ISSUE: 'createNewRepeaterIssue',
  UPDATE_RELATED_ALERTS_AS_UPDATER: 'updateRelatedAlertsAsUpdater',
  UPDATE_MXREC_TITLE: 'updateMxRecTitle',
  UPDATE_MXREC_DISCUSSIONS_LOADING: 'updateMxRecDiscussionsLoading',
  UPDATE_PRESERVED_DETAILS_DISCUSSION: 'updatePreservedDetailsDiscussion',
  UPDATE_PRESERVED_INVESTIGATION_DISCUSSION:
    'updatePreservedInvestigationDiscussion',
  GET_STATUS_UPDATE: 'getStatusUpdate',
  UPDATE_MXREC_STATUS_UPDATES_LOADING: 'updateMxRecStatusUpdatesLoading',
  UPDATE_STATUS_UPDATES: 'updateStatusUpdates',
  UPDATE_PRESERVED_STATUS_UPDATES: 'updatePreservedStatusUpdates',
}

export const GLOBAL_FILTER_CONSTS = {
  NAMESPACE: 'globalFilter',
  GET_GLOBAL_FILTER: 'getGlobalFilter',
  UPDATE_GLOBAL_FILTER: 'updateGlobalFilter',
  GET_GLOBAL_FILTER_CONFIRMATION: 'getGlobalFilterConformation',
  UPDATE_GLOBAL_FILTER_CONFIRMATION: 'updateGlobalFilterConfirmation',
}

export const FILTER_CONSTS = {
  NAMESPACE: 'filters',
  UPDATE_FILTER: 'updateFilter',
  CLEAR_FILTER: 'clearFilter',
  SAVE_FILTER: 'saveFilter',
  GET_FILTER: 'getFilter',
}

export const ACMF_REPORT_DETAILS_CONSTS = {
  NAMESPACE: 'acmfReportDetails',
  GET_REPORT_DATA: 'getReportData',
  GET_AIRCRAFT_DETAILS: 'getAircraftDetails',
  GET_PARAMETER_ALERT: 'getParameterAlert',
  GET_PARAMETER_DEFINITION: 'getParameterDefinition',
  GET_PARAMETER_GRAPH: 'getParameterGraph',
  GET_SERIES_DATA_GRAPH: 'getSeriesDataGraph',
  GET_FLEET_COMPARISON_DATA: 'getFleetComparisonData',
  GET_RAW_REPORT_TEXT: 'getRawReportText',
  GET_NEXT_REPORT_ID: 'getNextReportId',
  GET_REPORT_TIMELINES_DATA: 'getReportTimeLinesData',
  GET_GRAPH_GROUPS_PER_REPORT_TYPE: 'getGraphGroupsPerReportType',
  GET_REPORT_PLOT_GROUPS: 'getReportPlotGroups',
  GET_REPORT_PLOT: 'getReportPlot',
  UPDATE_REPORT_TIMELINES_DATA: 'updateReportTimeLinesData',
  UPDATE_IS_APU_REPORT: 'updateIsApuReport',
  UPDATE_REPORT_DATA: 'updateReportData',
  UPDATE_REPORT_ALERTS: 'updateReportAlerts',
  UPDATE_FAULT_MONITORS: 'updateFaultMonitors',
  UPDATE_AIRCRAFT_DETAILS: 'updateAircraftDetails',
  UPDATE_PARAMETER_ALERT: 'updateParameterAlert',
  UPDATE_PARAMETER_DEFINITION: 'updateParameterDefinition',
  UPDATE_PARAMETER_GRAPH: 'updateParameterGraph',
  UPDATE_FLEET_COMPARISON_DATA: 'updateFleetComparisonData',
  UPDATE_RAW_REPORT_TEXT: 'updateRawReportText',
  UPDATE_REPORT_DATA_LOADING: 'updateReportDataLoading',
  UPDATE_AIRCRAFT_DETAILS_LOADING: 'updateAircraftDetailsLoading',
  UPDATE_PARAMETER_ALERT_LOADING: 'updateParameterAlertLoading',
  UPDATE_PARAMETER_DEFINITION_LOADING: 'updateParameterDefinitionLoading',
  UPDATE_PARAMETER_GRAPH_LOADING: 'updateParameterGraphLoading',
  UPDATE_RAW_REPORT_TEXT_LOADING: 'updateRawReportTextLoading',
  UPDATE_FLEET_GRAPH_LOADING: 'updateFleetGraphLoading',
  UPDATE_REPORT_TIMELINES_DATA_LOADING: 'updateReportTimeLinesDataLoading',
  UPDATE_NEXT_REPORT_ID: 'updateNextReportId',
  UPDATE_PREVIOUS_REPORT_ID: 'updatePreviousReportId',
  GET_EXPORTED_REPORTS_GIVEN_REPORT_ID: 'getExportedReportsGivenReportId',
  UPDATE_REPORT_EXPORT_LOADING: 'updateReportExportLoading',
  UPDATE_GRAPH_GROUPS: 'updateGraphGroups',
  UPDATE_REPORT_TYPE: 'updateReportType',
  UPDATE_REPORT_PLOT_GROUPS: 'updateReportPlotGroups',
  UPDATE_REPORT_PLOT: 'updateReportPlot',
}

export const ACMF_REPORT_LIST_CONSTS = {
  NAMESPACE: 'acmfReportList',
  GET_ACMF_AIRLINES: 'getAcmfAirlines',
  GET_ACMF_MASTER_MODELS: 'getAcmfMasterModels',
  GET_ACMF_TAILS: 'getAcmfTails',
  GET_ACMF_SYSTEMS: 'getAcmfSystems',
  GET_ACMF_REPORT_TYPES: 'getAcmfReportTypes',
  GET_ACMF_PARAMETER_NAMES: 'getAcmfParameterNames',
  UPDATE_ACMF_AIRLINES: 'updateAcmfAirlines',
  UPDATE_ACMF_MASTER_MODELS: 'updateAcmfMasterModels',
  UPDATE_ACMF_TAILS: 'updateAcmfTails',
  UPDATE_ACMF_SYSTEMS: 'updateAcmfSystems',
  UPDATE_ACMF_REPORT_TYPES: 'updateAcmfReportTypes',
  UPDATE_ACMF_PARAMETER_NAMES: 'updateAcmfParameterNames',
  UPDATE_REPORT_LIST_FILTERS: 'updatesavedReportFilterFields',
  GET_REPORT_LIST_DATA: 'getReportListData',
  UPDATE_REPORT_LIST_DATA: 'updateReportListData',
  UPDATE_REPORT_LIST_DATA_LOADING: 'updateReportListDataLoading',
  GET_REPORT_EXPORT_GIVEN_REPORT_OPTIONS: 'getReportExportGivenReportOptions',
  UPDATE_REPORT_EXPORT_LOADING: 'updateReportExportLoading',
  GET_APU_CYCLE_EXPORT_GIVEN_OPTIONS: 'getApuCycleExportGivenOptions',
  UPDATE_APU_CYCLE_EXPORT_LOADING: 'updateApuCycleExportLoading',
  GET_FAULT_MONITOR_EXPORT_GIVEN_OPTIONS: 'getFaultMonitorExportGivenOptions',
  UPDATE_FAULT_MONITOR_EXPORT_LOADING: 'updateFaultMonitorExportLoading',
  GET_FLEET_ALERTS_EXPORT_GIVEN_OPTIONS: 'getFleetAlertsExportGivenOptions',
  UPDATE_FLEET_ALERTS_EXPORT_LOADING: 'updateFleetAlertsExportLoading',
  GET_FLEET_MESSAGES_EXPORT_GIVEN_OPTIONS: 'getFleetMessagesExportGivenOptions',
  UPDATE_FLEET_MESSAGES_EXPORT_LOADING: 'updateFleetMessagesExportLoading',
  GET_EVENT_REPORT_LIST_DATA: 'getEventReportListData',
  UPDATE_EVENT_REPORT_LIST_DATA: 'updateEventReportListData',
  UPDATE_EVENT_REPORT_LIST_DATA_LOADING: 'updateEventReportListDataLoading',
  UPDATE_EVENT_REPORT_LIST_FILTERS: 'updatesavedEventReportFilterFields',
  UPDATE_AIRLINE_MASTERMODEL_AGREEMENT: 'updateAirlineMastermodelAgreement',
}

export const ANALYTIC_MANAGEMENT_CONSTS = {
  NAMESPACE: 'analyticsManagement',
  GET_ALL_ANALYTICS: 'getAllAnalytics',
  ALL_ANALYTICS_LOADING: 'allAnalyticsLoading',
  UPDATE_ALL_ANALYTICS: 'updateAllAnalytics',
  GET_ANALYTIC_DETAILS: 'getAnalyticDetails',
  UPDATE_ANALYTIC_DETAILS: 'updateAnalyticDetails',
  UPDATE_ANALYTIC_DETAILS_LOADING: 'updateAnalyticDetailsLoading',
  SAVE_ANALYTIC_DETAILS: 'putAnalyticDetails',
  SAVE_ANALYTIC_DETAILS_LOADING: 'updatePutAnalyticDetailsLoading',
  TOAST_NOTIFICATION: 'toastNotification,',
}

export const ROLE_MANAGEMENT_CONSTS = {
  NAMESPACE: 'roleManagement',
  GET_ALL_ROLES: 'getAllRoles',
  UPDATE_ALL_ROLES: 'updateAllRoles',
  ALL_ROLES_LOADING: 'allRolesLoading',
  SAVE_ROLE_DETAILS: 'saveRoleDetails',
  GET_ALL_RESOURCES: 'getAllResources',
  UPDATE_ALL_RESOURCES: 'updateAllResources',
  UPDATE_ALL_RESOURCE_MODULES: 'updateAllResourceModules',
  GET_SINGLE_ROLE: 'getSingleRole',
  UPDATE_SINGLE_ROLE: 'updateSingleRole',
  UPDATE_ROLE_DETAILS: 'updateRoleDetails',
}

export const ATTACHMENT_CONSTS = {
  NAMESPACE: 'attachments',
  GET_ATTACHMENT: 'getAttachment',
  GET_ATTACHMENT_TYPES: 'getAttachmentTypes',
  UPDATE_ATTACHMENT_TYPES: 'updateAttachmentTypes',
  CANCEL_ATTACHMENT_UPLOAD: 'cancelAttachmentUpload',
  DELETE_ATTACHMENTS: 'deleteAttachments',
  SAVE_ATTACHMENT: 'saveAttachment',
  UPDATE_SAVE_ATTACHMENT_ERROR: 'updateSaveAttachmentError',
  UPDATE_UPLOADED_ATTACHMENTS: 'updateUploadedAttachments',
  SAVE_REMOVED_ATTACHMENT: 'saveRemovedAttachment',
  UPDATE_REMOVED_ATTACHMENTS: 'updatedRemovedAttachments',
  SAVE_UPDATED_ATTACHMENT: 'saveUpdatedAttachment',
  UPDATE_UPDATED_ATTACHMENTS: 'updateUpdatedAttachments',
  RESET_ATTACHMENTS: 'resetAttachments',
  UPDATE_ALL_ATTACHMENTS: 'updateAllAttachments',
  RESET_ATTACHMENT_ERRORS: 'resetAttachmentErrors',
  UPDATE_ATTACHMENT_ERRORS: 'updateAttachmentErrors',
  GET_ATTACHMENTS_BY_FILETYPE: 'getAttachmentsByFiletype',
}

export const AIRLINE_MANAGEMENT_CONSTS = {
  NAMESPACE: 'airlineManagement',
  GET_ALL_AIRLINES: 'getAllAirlines',
  FIND_AIRLINES: 'findAirlines',
  UPDATE_ALL_AIRLINES: 'updateAllAirlines',
  UPDATE_FILTERED_AIRLINES: 'updateFilteredAirlines',
  GET_AIRLINE: 'getAirline',
  UPDATE_AIRLINE: 'updateAirline',
  SAVE_UPDATED_AIRLINE: 'saveUpdatedAirline',
  SAVE_NEW_AIRLINE: 'saveNewAirline',
  NEW_AIRLINE_TOAST: 'newAirlineToast',
  EDIT_AIRLINE_TOAST: 'editAirlineToast',
  GET_ALL_AGREEMENTS: 'getAllAgreements',
  UPDATE_ALL_AGREEMENTS: 'updateAllAgreements',
  GET_AGREEMENT_TYPES: 'getAgreementTypes',
  UPDATE_AGREEMENT_TYPES: 'updateAgreementTypes',
  SAVE_NEW_AGREEMENT: 'saveNewAgreement',
  NEW_AGREEMENT_TOAST: 'newAgreementToast',
  UPDATE_AGREEMENT_TOAST: 'updateAgreementToast',
}

export const FEATURE_CONSTS = {
  NAMESPACE: 'feature',
  GET_ALL_FEATURES_BY_MODULE: 'getAllFeaturesByModule',
  UPDATE_ALL_FEATURES_BY_MODULE: 'updateAllFeaturesByModule',
  SAVE_FEATURE: 'saveFeature',
  GET_FEATURE: 'getFeature',
  UPDATE_FEATURE: 'updateFeature',
}

export const ALERT_TYPE_CONSTS = {
  NAMESPACE: 'alertType',
  GET_ALL_ALERT_TYPES_BY_MODULE: 'getAllAlertTypesByModule',
  UPDATE_ALL_ALERT_TYPES_BY_MODULE: 'updateAllAlertTypesByModule',
  SAVE_ALERT_TYPE: 'saveAlertType',
  GET_ALERT_TYPE: 'getAlertType',
  UPDATE_ALERT_TYPE: 'updateAlertType',
}

export const FLEET_CONSTS = {
  NAMESPACE: 'fleet',
  GET_FLEET_DATA: 'getFleetData',
  UPDATE_FLEET_DATA: 'updateFleetData',
  GET_OPEN_MAINTENANCE_DATA: 'getOpenMaintenanceData',
  UPDATE_OPEN_MAINTENANCE_DATA: 'updateOpenMaintenanceData',
  GET_FLIGHT_DECK_EFFECTS_DATA: 'getFlightDeckEffectsData',
  UPDATE_FLIGHT_DECK_EFFECTS_DATA: 'updateFlightDeckEffectsData',
  GET_HEALTH_SCORE_BY_TAIL_DATA: 'getHealthScoreByTailData',
  UPDATE_HEALTH_SCORE_BY_TAIL_DATA: 'updateHealthScoreByTailData',
  GET_HEALTH_SCORE_BY_FEATURE_DATA: 'getHealthScoreByFeatureData',
  UPDATE_HEALTH_SCORE_BY_FEATURE_DATA: 'updateHealthScoreByFeatureData',
  GET_HEALTH_SCORE_TREND_DATA: 'getHealthScoreTrendData',
  UPDATE_HEALTH_SCORE_TREND_DATA: 'updateHealthScoreTrendData',
  GET_HEALTH_SCORE_PHM_ALERT_DATA: 'getHealthScorePhmAlertData',
  UPDATE_HEALTH_SCORE_PHM_ALERT_DATA: 'updateHealthScorePhmAlertData',
  GET_HEALTH_SCORE_MX_REC_OVERLAYS_DATA: 'getHealthScoreMxRecOverlaysData',
  UPDATE_HEALTH_SCORE_MX_REC_OVERLAYS_DATA:
    'updateHealthScoreMxRecOverlaysData',
}

export const ISSUE_TYPE_CONSTS = {
  NAMESPACE: 'issueType',
  GET_ISSUE_TYPES: 'getIssueTypes',
  UPDATE_ISSUE_TYPES: 'updateIssueTypes',
}

export const USER_GUIDE_CONSTS = {
  NAMESPACE: 'userGuide',
  GET_ALL_USER_GUIDES: 'getAllUserGuides',
  UPDATE_USER_GUIDES_LOADING: 'updateUserGuidesLoading',
  UPDATE_ALL_USER_GUIDES: 'updateAllUserGuides',

  GET_ALL_USER_CONTENTS: 'getAllUserContents',
  UPDATE_USER_CONTENTS_LOADING: 'updateUserContentsLoading',
  UPDATE_USER_CONTENTS: 'updateUserContentTypes',

  GET_USER_CONTENT_BY_ID: 'getUserContentById',
  UPDATE_USER_CONTENT: 'updateUserContent',
  SAVE_USER_CONTENT: 'saveUserContent',
  UPDATING_CONTENT: 'updatingContent',

  GET_USER_GUIDE_BY_ID: 'getUserGuideById',
  UPDATE_USER_GUIDE_BY_ID: 'updateUserGuideById',
  SAVE_USER_GUIDE: 'saveUserGuide',
  UPDATE_USER_GUIDE: 'updateUserGuide',
  USER_GUIDE_DOWNLOAD: 'userGuideDownload',

  DELETE_USER_GUIDE: 'deleteUserGuide',
  GET_PDF_USER_GUIDE: 'getPdfUserGuide',
}

export const POWER_BI_CONSTS = {
  NAMESPACE: 'powerBi',
  GET_AIRLINE_WORKSPACES: 'getAirlineWorkspaces',
  UPDATE_AIRLINE_WORKSPACES: 'updateAirlineWorkspaces',
  GET_POWERBI_DATASET: 'getPowerBIDataset',
  UPDATE_POWERBI_DATASET: 'updatePowerBIDataset',
  CREATE_CLONE_POWERBI_DASHBOARD: 'createClonePowerBIDashboard',
  VALIDATE_POWERBI_DASHBOARD_NAME: 'validatePowerBIDashboardName',
  UPDATE_VALID_DASHBOARD_NAME: 'updateValidDashboardName',
  GET_AIRLINE_REPORTS: 'getAirlineReports',
  UPDATE_AIRLINE_REPORTS: 'updateAirlineReports',
  GET_DASHBOARD_EMBED_TOKEN: 'getDashboardEmbedToken',
  UPDATE_DASHBOARD_EMBED_TOKEN: 'updateDashboardEmbedToken',
  UPDATE_DUPLICATE_STATUS: 'updateDuplicateStatus',
  UPDATE_CREATED_OR_CLONED_RECORD: 'updateCreatedOrCLonedRecord',
  UPDATE_AIRLINE_REPORT: 'updateAirlineReport',
  UPDATE_SHARING_PERMISSIONS: 'updateSharingPermissions',
  DELETE_POWERBI_REPORT: 'deletePowerBIReport',
  SET_SELECTED_POWERBI_DASHBOARD: 'setSelectedPowerBIDashboard',
  UPDATE_SELECTED_POWERBI_DASHBOARD: 'updateSelectedPowerBIDashboard',
  REMOVE_SELECTED_POWERBI_DASHBOARD: 'removeSelectedPowerBIDashboard',
  UPDATE_PRESERVED_POWERBI_DASHBOARD: 'updatePreservedPowerBIDashboard',
  UPDATE_POWERBI_REPORT: 'updatePowerBIReport',
  CANCEL_CHANGES: 'cancelChanges',
}

export const PERMISSION_LEVEL_CONSTS = {
  NAMESPACE: 'permissionsLevel',
  READ: 1,
  EDIT: 2,
  DELETE: 4,
}

export const FEATURE_FLAG_CONSTS = {
  NAMESPACE: 'featureFlag',
  UPDATE_ALL_FEATURE_FLAGS: 'updateFeatureFlags',
  GET_ALL_FEATURE_FLAGS: 'getFeatureFlags',
}
